import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
const axios = require("axios").default;
axios.defaults.baseURL =
  "https://us-central1-novo-coopasvtech.cloudfunctions.net/painelProdutoresAPI";

interface FarmerInfo {
  docId: string;
  name: string;
  aboutMe: string | null;
  photoUrl: string | null;
}

interface FieldBlock {
  docId: string;
  coordinates: string;
  area: string;
  phase2Id: string;
  farmerId: string;
}

export interface ProdutoresState {
  listOfFarmesNameAndAboutMe: FarmerInfo[];
  statusListOfFarmes: "start" | "loading" | "failed" | "success";
  listOfFieldBlocksInfo: FieldBlock[];
  statusListOfFieldBlocks: "start" | "loading" | "failed" | "success";
}

const initialState: ProdutoresState = {
  listOfFarmesNameAndAboutMe: [],
  statusListOfFarmes: "start",
  listOfFieldBlocksInfo: [],
  statusListOfFieldBlocks: "start",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const getListOfFarmersInfo = createAsyncThunk(
  "produtores/getFarmersNameAndAboutMe",
  async () => {
    try {
      const response = await axios.get("/getFarmersNameAndAboutMe");
      //   console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
    // The value we return becomes the `fulfilled` action payload
  }
);

export const getListOfFieldBlocks = createAsyncThunk(
  "produtores/getFarmersInfoAndFieldBlocksInfo",
  async () => {
    try {
      const response = await axios.get("/getFarmersInfoAndFieldBlocksInfo");
      //   console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
    // The value we return becomes the `fulfilled` action payload
  }
);

export const produtoresSlice = createSlice({
  name: "produtores",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getListOfFarmersInfo.pending, (state) => {
        state.statusListOfFarmes = "loading";
      })
      .addCase(getListOfFarmersInfo.fulfilled, (state, action) => {
        state.statusListOfFarmes = "success";
        state.listOfFarmesNameAndAboutMe = action.payload;
      })
      .addCase(getListOfFieldBlocks.pending, (state) => {
        state.statusListOfFieldBlocks = "loading";
      })
      .addCase(getListOfFieldBlocks.fulfilled, (state, action) => {
        state.statusListOfFieldBlocks = "success";
        state.listOfFieldBlocksInfo = action.payload;
      });
  },
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectlistOfFarmesNameAndAboutMe = (state: RootState) =>
  state.produtores.listOfFarmesNameAndAboutMe;
export const selectStatusListOfFarmes = (state: RootState) =>
  state.produtores.statusListOfFarmes;
export const selectListOfFieldBlocks = (state: RootState) =>
  state.produtores.listOfFieldBlocksInfo;
export const selectStatusListOfFieldBlocks = (state: RootState) =>
  state.produtores.statusListOfFieldBlocks;

export default produtoresSlice.reducer;
